import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { Text } from "@cars24/turbo-web/lib/text";
import Slider from "../../shared/slick-wrapper";
import LazyImage from "../../shared/lazy-image";
import CommaIcon from "./images/comma.svg";
import GoogleIcon from "./images/google-icon.svg";
import RatingStar from "../../shared/rating-star";
import Star from "./images/star.svg";
import GreyStar from "./images/grey-star.svg";
import initialExtractor from "../../../utils/parsers/initial-extractor";

const GOOGLE = "GOOGLE";
const EliteTestimonials = ({
    section
}) => {

    const starColors = {
        fill: Star,
        transparent: GreyStar
    };

    const {pageSection = {} } = section || {};
    const { title = "Real stories. Elite experiences.", sectionData} = pageSection || {};
    const settings = {
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        speed: 800,
        dots: false,
        pauseOnHover: false,
        swipeToSlide: true,
        touchMove: true,
        rtl: false,
        cssEase: "ease-in-out",
        easing: "ease-in-out",
        fade: false,
        adaptiveHeight: false
    };
    const renderAvatar = (customerName) => {
        return (<span
            className="align-self-start mr-3"
            styleName={"styles.intials"}>
            {initialExtractor(customerName)}
        </span>);
    };

    return (
        <div styleName={"styles.eliteTestimonialsWrapper"}>
            <Text
                align="center"
                as="h2"
                fontWeight="semibold"
                size="650"
                transform="none"
                color={"#101010"}
            >
                {title}
            </Text>

            <Slider {...settings}>
                {
                    sectionData.map((item, index) => (
                        <div key={`elite-testimonials-${index}`} styleName={"styles.testimonialsCard"}>
                            <div styleName={"styles.testimonialsText"}>
                                <img src={CommaIcon} alt="comma" width="30px" />
                                <div styleName={"styles.description"}>
                                    <Text
                                        align="left"
                                        as="p"
                                        fontWeight="regular"
                                        size="300"
                                        transform="none"
                                        color={"#101010"}
                                    >
                                        {item.description}
                                    </Text>
                                </div>
                            </div>
                            <div styleName={"styles.userDetails"}>
                                {item?.image?.url ?  <LazyImage src={item?.image?.url} alt={item?.image?.alternativeText} /> : renderAvatar(item.userName)}
                                <div styleName={"styles.userSection"}>
                                    <div styleName={"styles.userName"}>
                                        <Text
                                            align="left"
                                            as="h5"
                                            fontWeight="regular"
                                            size="200"
                                            transform="none"
                                            color={"#0F0F10"}
                                        >
                                            {item.userName}
                                        </Text>
                                        <Text
                                            align="left"
                                            as="p"
                                            fontWeight="regular"
                                            size="200"
                                            transform="none"
                                            color={"#717272"}
                                        >
                                            {new Date(item.publishedDate).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}
                                        </Text>
                                    </div>
                                    <div styleName={"styles.ratting"}>
                                        {item.testimonialSource === GOOGLE &&  <img src={GoogleIcon} alt="google" width="16px" height="16px" />}
                                        <RatingStar starColors={starColors} avgRating={item.rating} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </Slider>
        </div>
    );
};

EliteTestimonials.propTypes = {
    section: PropTypes.object
};

export default EliteTestimonials;
